import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "styles/components/Header.styles";
import AvatarMenu from "components/AvatarMenu";
import IconButton from "@material-ui/core/IconButton";
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import BookmarksOutlinedIcon from '@material-ui/icons/BookmarksOutlined';
import { RoutingProps, TemplateSocials } from "types/app";
import { Palette } from "@material-ui/core/styles/createPalette";

interface Props extends RoutingProps {
  title: string;
  loggedIn: boolean;
  isAdmin: boolean;
  socials: TemplateSocials;
  palette: Palette;
  loading: boolean;
  profileImg: string | undefined;
  handleAddPost: () => void;
  handleLogout: () => void;
  handleLogin: () => void;
  handleBookmarks: () => void;
  handleSocials: (id: string) => void;
  toHome: () => void;
  logo?: string;
}

const StandardHeader: React.FunctionComponent<Props> = ({
  title,
  loggedIn,
  isAdmin,
  socials,
  palette,
  loading,
  profileImg,
  handleAddPost,
  handleLogout,
  handleLogin,
  handleBookmarks,
  handleSocials,
  toHome,
  handleRoute,
  logo,
}) => {
  const classes = useStyles();
  // const handleWebsite = () => handleSocials("website");
  // const handleFacebook = () => handleSocials("facebook");
  // const handleInstagram = () => handleSocials("instagram");
  // const handleTwitter = () => handleSocials("twitter");
  // const handleTelegram = () => handleSocials("telegram");
  // const handleLinkedIn = () => handleSocials("linkedIn");
  // const handleMedium = () => handleSocials("medium");
  // const handleYouTube = () => handleSocials("youTube");

  return (
    <>
      <div className={classes.leftContainer}>
        {logo ? (
          <img
            src={`${process.env.PUBLIC_URL}/${logo}`}
            alt={title}
            className={classes.logo}
            onClick={toHome}
          />
        ) : (
          <Typography variant="h4" onClick={toHome} className={classes.title}>
            {title}
          </Typography>
        )}
      </div>
      <div className={classes.rightContainer}>
        {/*<div className={classes.socialRow}>
          {socials.hasWebsite && (
            <IconButton
              id="website"
              className={classes.socialIcon}
              onClick={handleWebsite}
            >
              <CustomIcon type="website" color={palette.primary.contrastText} />
            </IconButton>
          )}
          {socials.hasFacebook && (
            <IconButton
              id="facebook"
              className={classes.socialIcon}
              onClick={handleFacebook}
            >
              <CustomIcon
                type="facebook"
                color={palette.primary.contrastText}
              />
            </IconButton>
          )}
          {socials.hasInstagram && (
            <IconButton
              id="instagram"
              className={classes.socialIcon}
              onClick={handleInstagram}
            >
              <CustomIcon
                type="instagram"
                color={palette.primary.contrastText}
              />
            </IconButton>
          )}
          {socials.hasTwitter && (
            <IconButton
              id="twitter"
              className={classes.socialIcon}
              onClick={handleTwitter}
            >
              <CustomIcon type="twitter" color={palette.primary.contrastText} />
            </IconButton>
          )}
          {socials.hasTelegram && (
            <IconButton
              id="telegram"
              className={classes.socialIcon}
              onClick={handleTelegram}
            >
              <CustomIcon
                type="telegram"
                color={palette.primary.contrastText}
              />
            </IconButton>
          )}
          {socials.hasLinkedIn && (
            <IconButton
              id="linkedIn"
              className={classes.socialIcon}
              onClick={handleLinkedIn}
            >
              <CustomIcon
                type="linkedIn"
                color={palette.primary.contrastText}
              />
            </IconButton>
          )}
          {socials.hasMedium && (
            <IconButton
              id="medium"
              className={classes.socialIcon}
              onClick={handleMedium}
            >
              <CustomIcon type="medium" color={palette.primary.contrastText} />
            </IconButton>
          )}
          {socials.hasYouTube && (
            <IconButton
              id="youTube"
              className={classes.socialIcon}
              onClick={handleYouTube}
            >
              <CustomIcon type="youTube" color={palette.primary.contrastText} />
            </IconButton>
          )}
        </div>*/}
        {loggedIn && (
          <IconButton aria-label="like" size="small" style={{ marginRight: "8px" }}
            onClick={handleBookmarks}
          >
            <BookmarksOutlinedIcon />
          </IconButton>
        )}
        {isAdmin && (
          <Button
            variant="outlined"
            onClick={handleAddPost}
          >
            Add Post
          </Button>
        )}
        {loading ? (
          <CircularProgress
            color="secondary"
          />
        ) : loggedIn ? (
          <AvatarMenu
            onLogout={handleLogout}
            profileImg={profileImg as string}
            isAdmin={isAdmin}
            handleRoute={handleRoute}
          />
        ) : (
          <Button
            variant="outlined"
            onClick={handleLogin}
            // color="secondary"
            startIcon={<AccountCircleRoundedIcon />}
          >
            Log in
          </Button>
        )}
      </div>
    </>
  );
};

export default StandardHeader;
